import { COMPANY_EMAILS } from "@repo/common";
import audaciousLogo from "public/investors/audacious.svg";
import emergenceLogo from "public/investors/emergence.svg";
import signalFireLogo from "public/investors/signalfire.svg";
import svAngelLogo from "public/investors/sv-angel.svg";
import zfellowsLogo from "public/investors/z-fellows.svg";

import { TEAM } from "../team/_components/team-data";

export const investors = [
  { name: "Emergence", image: emergenceLogo, href: "https://www.emcap.com/" },
  { name: "Audacious", image: audaciousLogo, href: "https://www.audacious.co" },
  {
    name: "SignalFire",
    image: signalFireLogo,
    href: "https://www.signalfire.com/",
  },
  { name: "SV Angel", image: svAngelLogo, href: "https://www.svangel.com/" },
  { name: "Z Fellows", image: zfellowsLogo, href: "https://www.zfellows.com/" },
];

export const teamMembers: { name: string; role: string; src: string }[] =
  TEAM.flatMap((group) => group.members)
    .filter((member): member is typeof member & { image: string } =>
      Boolean(member.image),
    )
    .map((member) => ({
      name: member.name,
      role: member.role,
      src: member.image,
    }));

export const stats = [
  { label: "Raised", value: "$9M" },
  { label: "Founded", value: "2025" },
  { label: "Team", value: String(teamMembers.length) },
  { label: "HQ", value: "San Francisco" },
];

export const jobs = [
  {
    title: "Founding Engineer",
    department: "Engineering",
    location: "San Francisco",
    type: "Full-time",
    href: "https://jobs.ashbyhq.com/terac/575c045f-fbef-4889-b558-a3c2bd6b60d6",
  },
  {
    title: "Founding Account Executive",
    department: "Growth",
    location: "San Francisco",
    type: "Full-time",
    href: "https://jobs.ashbyhq.com/terac/e61d8f3a-d59a-43cf-b9f6-a9e7eeabffee",
  },
  {
    title: "Founding Marketing",
    department: "Growth",
    location: "San Francisco",
    type: "Full-time",
    href: "https://jobs.ashbyhq.com/terac/44bc7549-9ef3-4c4f-b55f-468aaa12ef55",
  },
  {
    title: "Campus Ambassador, Academia",
    department: "Growth",
    location: "Virtual",
    type: "Part-time",
    href: "https://jobs.ashbyhq.com/terac/432eb714-577c-4c6a-aedc-6f47d52bb5ef",
  },
  {
    title: "Campus Ambassador, Expert Recruitment",
    department: "Growth",
    location: "Virtual",
    type: "Part-time",
    href: "https://jobs.ashbyhq.com/terac/fab6d64c-271c-42fc-af75-0050ec838408",
  },
  {
    title: "Founding Operations",
    department: "Operations",
    location: "San Francisco",
    type: "Full-time",
    href: "https://jobs.ashbyhq.com/terac/1f185bbb-fbca-4c4d-9bb8-2d58ad7bc6aa",
  },
  {
    title: "Recruiting Coordinator",
    department: "Operations",
    location: "San Francisco",
    type: "Full-time",
    href: "https://jobs.ashbyhq.com/terac/6d992fab-a78a-4a06-be6c-9994e4ec079b",
  },
  {
    title: "Founding Brand and Marketing",
    department: "Marketing",
    location: "San Francisco",
    type: "Full-time",
    href: `mailto:${COMPANY_EMAILS.careers}?subject=Application: Founding Brand and Marketing`,
  },
];

export const benefits = [
  {
    label: "01",
    title: "Healthcare",
    body: "Comprehensive health, dental, and vision coverage for you and your dependents.",
  },
  {
    label: "02",
    title: "Competitive compensation",
    body: "Meaningful salary and early-stage equity. We hire the best and treat them accordingly.",
  },
  {
    label: "03",
    title: "Relocation support",
    body: "Housing and relocation bonuses to help you make the move to San Francisco.",
  },
  {
    label: "04",
    title: "Ground-floor opportunity",
    body: `Join a team of ${teamMembers.length} building the infrastructure for the post-AGI economy. Early employees shape the company.`,
  },
  {
    label: "05",
    title: "Team events",
    body: "We celebrate wins with offsites and events that connect us beyond work.",
  },
  {
    label: "06",
    title: "Free meals",
    body: "Daily lunches, dinners, and snacks at the office to keep you at your best.",
  },
];

export const lifeRowOne = [
  { src: "/marketing/life/life-01.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-02.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-03.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-04.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-06.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-07.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-08.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-09.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-10.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-11.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-12.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-13.jpg", tag: "Life", label: "" },
];

export const lifeRowTwo = [
  { src: "/marketing/life/life-14.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-15.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-16.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-17.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-18.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-19.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-20.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-21.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-22.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-23.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-24.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-25.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-26.jpg", tag: "Life", label: "" },
  { src: "/marketing/life/life-27.jpg", tag: "Booth", label: "" },
];

export type TileSize = "sm" | "md" | "lg" | "xl";
export const sizesA: TileSize[] = [
  "md",
  "lg",
  "sm",
  "md",
  "xl",
  "sm",
  "md",
  "lg",
];
export const sizesB: TileSize[] = [
  "lg",
  "sm",
  "md",
  "xl",
  "md",
  "sm",
  "lg",
  "md",
];
